// extracted by mini-css-extract-plugin
export var container = "LocalePickerPage-module__container___eb3Cy";
export var content = "LocalePickerPage-module__content___+RIvz";
export var localeButton = "LocalePickerPage-module__localeButton___cqGPk";
export var options = "LocalePickerPage-module__options___N--Ru";
export var region = "LocalePickerPage-module__region___ObjGT";
export var regionTitle = "LocalePickerPage-module__regionTitle___5qnrf";
export var regions = "LocalePickerPage-module__regions___rg-Fd";
export var title = "LocalePickerPage-module__title___0IB5+";